import { USER_TYPE_CAPABILITIES, USER_TYPE_NAME } from '../../constants/user-type.js';
import GROUPED_STUDENT_FEATURES from '../../constants/grouped-student-features.js';

//

function _expandStudent(student, isVT4S, entity) {
  return {
    avatar: student.avatar_url,
    email: student.email,
    enablements: student.enablements,
    firstName: student.first_name,
    getEnablement(search) {
      return _getEnablement({ enablements: student.enablements, entity, search });
    },
    grade: student.grade_list_id,
    hasEnablement(search) {
      return Boolean(this.getEnablement(search));
    },
    isVT4S,
    lastName: student.last_name,
    userId: student.user_id,
    uuid: student.uuid,
  };
}

function _UserCapabilities(userType) {
  return {
    includes(capabilities) {
      if (!Array.isArray(capabilities)) {
        capabilities = [capabilities];
      }
      return capabilities.every(
        (capability) => USER_TYPE_CAPABILITIES[userType]?.[capability] !== false
      );
    },
  };
}

//

function _getEnablementFromEntity(entity, search) {
  for (const student of entity.students) {
    const enablement = _getEnablement({ enablements: student.enablements, search });
    if (enablement) {
      return enablement;
    }
  }
}

function _getEnablement({ enablements, entity, search }) {
  if (entity && GROUPED_STUDENT_FEATURES.includes(search)) {
    return _getEnablementFromEntity(entity, search);
  }

  return enablements?.find(({ configuration, product }) => {
    if (typeof search === 'string') {
      return product.short_name === search;
    }

    return product.type === search.type && configuration?.tag === search.tag;
  });
}

// Exports
// -------

export default function LabUser({
  entity = {},
  entity: {
    client_id: clientId,
    client_uuid: clientUuid,
    display_name: displayName,
    email,
    first_name: firstName,
    id,
    jurisdiction_id: jurisdictionId,
    lab_user_type: type,
    last_name: lastName,
    login,
    product_state: productState,
    role,
    sales_group_list: salesGroupIds,
    tutor_id: tutorId,
    tutor_uuid: tutorUuid,
  } = {},
  students,
  token: { roles, user_id: userId } = {},
} = {}) {
  if (!userId) {
    return;
  }

  const capabilities = _UserCapabilities(type);
  const isVT4S =
    entity.role === 'student' || entity.is_client === false || entity.product_state === 'vt4s';
  const roleTypeName = USER_TYPE_NAME[type];

  const user = {
    capabilities,
    clientId,
    clientUuid,
    displayName,
    email,
    entityId: id,
    firstName,
    id: userId,
    jurisdictionId,
    lastName,
    login,
    primaryRole: roleTypeName,
    productState,
    role,
    roles,
    salesGroupIds,
    tutorId,
    tutorUuid,
    type,
    uuid: entity[`${roleTypeName}_uuid`],
  };

  user.students = students?.map((student) => _expandStudent(student, isVT4S, user));

  return user;
}
